import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountService from '@api/account/account';
import { isLoggedIn, useGlobalContext } from '@/globalContext';
import Config from '@utils/config';
import { LOGIN_PATH, ROOT_PATH } from '@utils/constants/Routes';
import { Dialog } from '@components/commons';
import { ConfigProps } from '@components/config/ConfigPanel';
import styles from './header.module.scss';
import { IconHouse, IconLogOut } from '@yoti/ui-kit-components-react/globals';
const accountService = new AccountService(Config.apiUrl);

interface Props {
    hasLinkToMainPage: boolean;
}

const Header: React.FC<Props> = ({ hasLinkToMainPage }) => {
    const [openLogoutDialog, setOpenLogoutDialog] = useState<boolean>(false);
    const globalContext = useGlobalContext();
    const { account, set } = globalContext;

    const navigate = useNavigate();
    const logged = isLoggedIn(account);

    const handleLogout = () => {
        accountService.logout();

        // Set consent to be false if the user logout.
        const newScanConfig = Object.assign(new ConfigProps(), globalContext.scanConfiguration);
        newScanConfig.consent = false;
        globalContext.setScanConfiguration(newScanConfig);

        set({
            ...globalContext,
            account: undefined,
            accountChecked: false,
            scanConfiguration: newScanConfig,
        });
        navigate(LOGIN_PATH);
    };

    return (
        <>
            {logged && (
                <div className={styles['header']}>
                    {hasLinkToMainPage && (
                        <IconHouse
                            className={`${styles['header__icon']} ${styles['header__icon--main-page']}`}
                            onClick={() => {
                                set({
                                    ...globalContext,
                                    scanSelectedTab: undefined,
                                    faceMatchingSelectedTab: undefined,
                                });
                                navigate(ROOT_PATH);
                            }}
                            data-qa="main-page-icon"
                        />
                    )}
                    <IconLogOut
                        className={`${styles['header__icon']} ${styles['header__icon--log-out']}`}
                        onClick={() => setOpenLogoutDialog(true)}
                        data-qa="log-out-icon"
                    />
                    {openLogoutDialog && (
                        <Dialog
                            title={'Log out'}
                            action={'LOG OUT'}
                            onConfirm={handleLogout}
                            onClose={() => setOpenLogoutDialog(false)}
                            message={'log out'}
                        ></Dialog>
                    )}
                </div>
            )}
        </>
    );
};

export default Header;
